import { useEffect, useState } from "react";
import {
  RiLock2Fill,
  RiSave2Fill,
  RiShieldKeyholeLine,
  RiInformationLine,
} from "react-icons/ri";
import { Formik } from "formik";
import * as Yup from "yup";
import Axios from "../../Axios";
import { useAuthContext } from "../../context/AuthContext";
import { MyInput } from "../../ui";
import Loader from "../../utils/Loader/Loader";
import Popup from "../../utils/Popup/Popup";
import "./changePassword.scss";

const schema = Yup.object().shape({
  old_password: Yup.string()
    .min(8, "Хамгийн багадаа 8 тэмдэгт байх ёстой!")
    .required("Хоосон байна!"),
  new_password: Yup.string()
    .min(8, "Хамгийн багадаа 8 тэмдэгт байх ёстой!")
    .required("Хоосон байна!"),
  repassword: Yup.string()
    .oneOf([Yup.ref("new_password")], "Таарахгүй байна!")
    .required("Хоосон байна!"),
});

const ChangePassword = () => {
  const { authConfig, loginHandler } = useAuthContext();

  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const [popupType, setPopupType] = useState("");
  const [popupText, setPopupText] = useState("");
  const [visiblePopup, setVisiblePopup] = useState(false);

  useEffect(() => {
    if (authConfig) {
      Axios.get("/auth/me", authConfig).then((res) => {
        if (res.status === 200) {
          setEmail(res.data.email);
        }
      });
    }
  }, [authConfig]);

  const saveHandler = (values) => {
    setIsLoading(true);

    const DATA = {
      email,
      oldPassword: values.old_password,
      newPassword: values.new_password,
    };

    Axios.put("/users/change-password", DATA, authConfig)
      .then((res) => {
        if (res.data.message === "success") {
          setPopupType("success");
          setPopupText("Таны нууц үг амжилттай солигдлоо.");
          setNewPassword(values.new_password);
        } else {
          setPopupType("sys_error");
          setPopupText("Ямар нэгэн алдаа гарлаа. Та дахин оролдоно уу!");
        }

        setVisiblePopup(true);
      })
      .catch(() => {
        setPopupType("sys_error");
        setPopupText("Ямар нэгэн алдаа гарлаа. Та дахин оролдоно уу!");
        setVisiblePopup(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const popupOnOK = () => {
    if (popupType === "sys_error") {
      window.location.reload();
    } else {
      loginHandler({
        email,
        password: newPassword,
        doReload: true,
      });
    }
  };

  return (
    <div className="passwordPage">
      <Popup
        messageType={popupType}
        messageText={popupText}
        visible={visiblePopup}
        onOk={popupOnOK}
      />

      <div className="passwordCard">
        <div className="passwordCard__header">
          <div>
            <div className="passwordCard__eyebrow">Security</div>
            <h2 className="passwordCard__title">Нууц үг солих</h2>
            <p className="passwordCard__desc">
              Аюулгүй байдлаа хамгаалахын тулд шинэ нууц үгээ оруулна уу.
            </p>
          </div>

          <div className="passwordCard__badge">
            <RiShieldKeyholeLine />
            <span>Нууцлал</span>
          </div>
        </div>

        <Formik
          initialValues={{
            old_password: "",
            new_password: "",
            repassword: "",
          }}
          validationSchema={schema}
          onSubmit={(values) => saveHandler(values)}
        >
          {({
            values,
            errors,
            touched,
            setFieldTouched,
            handleChange,
            handleSubmit,
          }) => (
            <form className="passwordForm" onSubmit={handleSubmit}>
              <div className="passwordForm__layout">
                <div className="passwordHintCard">
                  <div className="passwordHintCard__icon">
                    <RiInformationLine />
                  </div>
                  <div className="passwordHintCard__title">
                    Нууц үгийн зөвлөмж
                  </div>
                  <ul className="passwordHintCard__list">
                    <li>Хамгийн багадаа 8 тэмдэгттэй байх</li>
                    <li>Том, жижиг үсэг хослуулбал сайн</li>
                    <li>Тоон тэмдэгт ашиглавал аюулгүй</li>
                    <li>Хуучин нууц үгээ дахин бүү ашигла</li>
                  </ul>
                </div>

                <div className="passwordFieldsCard">
                  <div className="passwordFieldsCard__grid">
                    <div className="passwordField passwordField--full">
                      <label className="passwordField__label">
                        Хуучин нууц үг
                      </label>
                      <MyInput
                        icon={<RiLock2Fill />}
                        name="old_password"
                        value={values.old_password}
                        type="password"
                        onChange={handleChange}
                        onBlur={setFieldTouched}
                        touched={touched.old_password}
                        errorText={errors.old_password}
                      />
                    </div>

                    <div className="passwordField">
                      <label className="passwordField__label">
                        Шинэ нууц үг
                      </label>
                      <MyInput
                        icon={<RiLock2Fill />}
                        name="new_password"
                        value={values.new_password}
                        type="password"
                        onChange={handleChange}
                        onBlur={setFieldTouched}
                        touched={touched.new_password}
                        errorText={errors.new_password}
                      />
                    </div>

                    <div className="passwordField">
                      <label className="passwordField__label">
                        Шинэ нууц үг давтах
                      </label>
                      <MyInput
                        icon={<RiLock2Fill />}
                        name="repassword"
                        value={values.repassword}
                        type="password"
                        onChange={handleChange}
                        onBlur={setFieldTouched}
                        touched={touched.repassword}
                        errorText={errors.repassword}
                      />
                    </div>
                  </div>

                  <div className="passwordForm__actions">
                    {isLoading ? (
                      <Loader mini />
                    ) : (
                      <button className="passwordSaveBtn" type="submit">
                        <RiSave2Fill />
                        <span>Хадгалах</span>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default ChangePassword;
